import { Button, Typography } from '@mui/material';
import { memo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { addCatalogItemActions } from 'features/AddCatalogItem/model/slices/AddCatalogItemSlice';
import { useAppDispatch } from 'shared/lib/hooks/useAppDispatch';

import { AddCatalogItemDialog } from '../AddCatalogItemDialog/AddCatalogItemDialog';

interface AddToPropertyCatalogButtonProps {
    disabled: boolean;
}

export const AddToPropertyCatalogButton = memo(
    ({ disabled }: AddToPropertyCatalogButtonProps) => {
        const dispatch = useAppDispatch();
        const { t } = useTranslation();

        const onAddNewItem = useCallback(() => {
            dispatch(addCatalogItemActions.setShowDialog(true));
        }, [dispatch]);

        return (
            <>
                <Button
                    data-testid="add-to-property-catalog-button"
                    disabled={disabled}
                    variant="contained"
                    onClick={onAddNewItem}
                >
                    <Typography typography="openSans.button">
                        {t('Add to property catalog')}
                    </Typography>
                </Button>
                <AddCatalogItemDialog />
            </>
        );
    },
);
